import React from 'react';
import { styled } from '@mui/material';
import { Autorenew, OpenInNew } from '@mui/icons-material';
import FindChildCareNCLogo from 'assets/images/FindChildCareNCLogo.png';
import { Colors } from 'library';
import { Card, PillButton, Row, Stack, Text } from 'library/ui';

const LINK = 'https://findchildcarenc.org/provider_access';

export function NCVacanciesCard() {
    return (
        <Stack padding="sm">
            <Card padding="sm" tone="muted">
                <Stack gap="sm">
                    <Card padding="xs">
                        <Logo src={FindChildCareNCLogo} alt="Find Child Care North Carolina" />
                    </Card>
                    <Row gap="sm" align="center">
                        <Autorenew sx={{ fontSize: 18, color: Colors.primary }} />
                        <Text size="sm" weight="bold">
                            Update Vacancies
                        </Text>
                    </Row>
                    <Text size="xs">
                        Families are searching for open spots — claim your profile and list your availability so they
                        can find you. As enrollment grows, Tandem keeps you staffed.
                    </Text>
                    <PillButton color="#7824a2" hoverColor="#7A36C4" onClick={() => window.open(LINK, '_blank')}>
                        <Text size="sm" weight="bold" tone="overlay">
                            Update Now
                        </Text>
                        <OpenInNew sx={{ fontSize: 16, color: Colors.white }} />
                    </PillButton>
                </Stack>
            </Card>
        </Stack>
    );
}

const Logo = styled('img')({
    height: 28,
    width: 'auto',
    display: 'block',
});
